const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";
export const API_ORIGIN = API_BASE_URL.replace(/\/api\/?$/, "");

const AUTH_REDIRECT_MESSAGES = new Set([
  "Authentication token is required",
  "Authentication token is invalid or expired",
]);

let redirectingToLogin = false;

function redirectToLogin() {
  localStorage.removeItem("authToken");
  localStorage.removeItem("authUser");

  if (typeof window === "undefined" || redirectingToLogin) return;

  redirectingToLogin = true;
  if (window.location.pathname !== "/account") {
    window.location.replace("/account");
  }
}

async function request(path, options = {}) {
  const token = localStorage.getItem("authToken");
  const headers = {
    "Content-Type": "application/json",
    ...options.headers,
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers,
  });
  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    if (response.status === 401 && AUTH_REDIRECT_MESSAGES.has(data.message)) {
      redirectToLogin();
    }

    throw new Error(data.message || "Request failed");
  }

  return data;
}

export const api = {
  get: (path) => request(path),
  post: (path, body) => request(path, { method: "POST", body: JSON.stringify(body) }),
  patch: (path, body) => request(path, { method: "PATCH", body: JSON.stringify(body) }),
  delete: (path) => request(path, { method: "DELETE" }),
};
